import { useMemo } from 'react';
import { useCurrentUser } from 'FrontRoyalAngular';
import { useStreams } from './useStream';

export const useBookmarkedStreams = () => {
    const currentUser = useCurrentUser();
    const favoriteStreamLocalePackIds = useMemo(
        () => currentUser?.favoriteLessonStreamLocalePacks?.map(lp => lp.id) ?? [],
        [currentUser],
    );

    return useStreams(favoriteStreamLocalePackIds);
};
